import React from "react";
import logo from "../img/logo-graphic.png";
import background from "../img/footer-bg.svg";
import { Link } from "react-router";

function Footer() {
  return (
    <footer className="footer container-fluid"  role="contentinfo"   style={{ backgroundImage: `url(${background})` }}  >
      <div className="footer-content">
        <div className="container">

        <div className="row pt-4">
        <aside className="col-md-4 col-sm-12 col-xs-12">
          <h3>
              <img className="mr-2" alt="City of Bellevue seal" src={logo} />
              <span className="align-middle">City of Bellevue, WA</span>
            </h3>

            <ul className="list-unstyled ml-1">
                  <li><em className="fa fa-location-dot mr-2"></em>450 110th Avenue NE</li>
                  <li className="ml-4">Bellevue, WA 98004</li>
                  <li><a href="https://www.google.com/maps/place/Bellevue+City+Hall/@47.6144305,-122.1929512,18z"
                              className="ext" data-extlink="" target="_blank" rel="noopener nofollow"
                              title="(opens in a new window)"><em className="fa fa-route mr-2"></em>Directions to City
                              Hall</a></li>
                  <li><em className="fa-solid fa-phone mr-2"></em><a href="tel:4254526800">425-452-6800</a></li>
                  <li><em className="fa-solid fa-envelope mr-2"></em><a
                              href="mailto:servicefirst@bellevuewa.gov">servicefirst@bellevuewa.gov</a>
                  </li>
                  <li><em className="fa-solid fa-address-book mr-2"></em><a href="https://bellevuewa.gov/contact-us">Contact Us / City
                              Directory</a></li>
                  <li><em className="fa-solid fa-clock mr-2"></em>Monday - Friday 8 a.m. - 4
                        p.m.
                  </li>
            </ul>
            <nav role="navigation" id="block-footermenucontacts"
                  className=" menu--footer-menu-contacts">
                  <h2 className="visually-hidden" id="block-footermenucontacts-menu">Footer Menu Contacts</h2>
                  <ul className="menu list-unstyled">
                        <li className="menu-item">
                              <a href="https://assist.bellevuewa.gov"
                                    className="cob-icon">MyBellevue Customer Assistance</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://www.governmentjobs.com/careers/bellevuewa" className="briefcase ext"
                                    data-extlink="" target="_blank" rel="noopener nofollow"
                                    title="(opens in a new window)"><i className="fa fas fa-briefcase"
                                          aria-hidden="true"></i> <span className="link-text">Careers</span></a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/resident-resources/adatitle-vi-resources"><i className="fab fa-accessible-icon"
                                          aria-hidden="true"></i> <span className="link-text">ADA/Title VI
                                          Notices</span></a>
                        </li>
                  </ul>



            </nav>

            <nav role="navigation" aria-labelledby="block-footermenusocialmedia-menu" id="block-footermenusocialmedia"
                  className=" menu--footer-menu-social-media">
                  <ul className="menu">
                        <li aria-label="Facebook" className="menu-item">
                              <a href="https://www.facebook.com/bellevuewashington" target="_blank" className="facebook ext"
                                    title="Facebook (opens in a new window)" data-extlink="" rel="noopener nofollow"><i
                                          className="fab fab fa-facebook" aria-hidden="true"></i></a>
                        </li>
                        <li aria-label="Instagram" className="menu-item">
                              <a href="https://www.instagram.com/cityofbellevuewa/"
                                    title="Instagram (opens in a new window)" className="ext" data-extlink=""
                                    target="_blank" rel="noopener nofollow"><i className="fa fab fa-instagram"
                                          aria-hidden="true"></i></a>
                        </li>
                        <li aria-label="Twitter" className="menu-item">
                              <a href="https://twitter.com/bellevuewa" target="_blank" className="twitter ext"
                                    title="X/Twitter (opens in a new window)" data-extlink="" rel="noopener nofollow"><i
                                          className="fa-brands fa-x-twitter" aria-hidden="true"></i></a>
                        </li>
                        <li aria-label="Youtube" className="menu-item">
                              <a href="https://www.youtube.com/channel/UCW22suSoHWumwarCbu3NkOg" target="_blank"
                                    className="youtube ext" title="YouTube (opens in a new window)" data-extlink=""
                                    rel="noopener nofollow"><i className="fa fab fa-youtube" aria-hidden="true"></i></a>
                        </li>
                        <li aria-label="Bluesky" className="menu-item">
                              <a href="https://bsky.app/profile/cityofbellevuewa.bsky.social" target="_blank"
                                    className="youtube ext" title="Blue Sky (opens in a new window)" data-extlink=""
                                    rel="noopener nofollow"><i className="fa fab fa-brands fa-bluesky" aria-hidden="true"></i></a>
                        </li>
                  </ul>



            </nav>

      </aside>
      <aside className="col-md-4 col-sm-12 col-xs-12">
            <nav role="navigation" aria-labelledby="block-footermenulanguages-menu" id="block-footermenulanguages"
                  className="block-footermenusocialmedia-menu menu--footer-menu-languages">

                  <h2 id="block-footermenulanguages-menu">Languages</h2>

                  <ul className="menu list-unstyled">
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov">English</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/es/welcome">Español</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/zh-hans/welcome">简体中文</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/zh-hant/welcome">繁體中文</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/ja/welcome">日本語</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/ko/welcome">한국어</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/ru/welcome">Pусский</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/vi/welcome">Tiếng Việt</a>
                        </li>
                  </ul>



            </nav>


      </aside>
      <aside  className="col-md-4 col-sm-12 col-xs-12">
            <nav role="navigation" aria-labelledby="block-footerrequesttranslation-2-menu"
                  id="block-footerrequesttranslation-2"
                  className=" menu--footer-request-translation">
                  <h2 id="block-footerrequesttranslation-2-menu">Request a Translation</h2>

                  <ul className="menu list-unstyled">
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/request-translation">Request a Translation</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/ar/atlb-trjmt">اطلب ترجمة</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/zh-hans/shenqingfanyi">申请翻译</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/zh-hant/yaoqiufanyi">要求翻譯</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/hi/anauvaada-kaa-anauraodha-karaen">अनुवाद का अनुरोध
                                    करें</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/ja/fanyiworikuesutosuru">翻訳をリクエストする</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/ko/beonyeog-yocheong">번역 요청</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/fa/drkhwast-trjmh">درخواست ترجمه</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/pa/anauvaada-dai-baeenatai-karaoo">ਅਨੁਵਾਦ ਦੀ ਬੇਨਤੀ
                                    ਕਰੋ</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/ru/zapros-na-perevod">Запрос на перевод</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/es/solicitud-de-traduccion">Solicitud de
                                    traducción</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/te/anauvaaadam-adagamdai">అనువాదం అడగండి</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/ur/trjmyky-lyy-ayk-drkhwast">ترجمےکے لئے ایک
                                    درخواست</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/vi/yeu-cau-ban-dich">Yêu cầu bản dịch</a>
                        </li>
                        <li className="menu-item">
                              <a href="https://bellevuewa.gov/am/teregume-mathayaqe">ትርጉም መጠየቅ</a>
                        </li>
                  </ul>



            </nav>

      </aside>
</div>

        </div>
        <div className="row">
      <div className="container">
            <hr />
          <aside className="col-sm-12">
            <hr></hr>
            <div>
              <p>
                © 2021&nbsp;City of Bellevue | All Rights Reserved. |{" "}
                <a href="https://bellevuewa.gov/city-government/departments/city-managers-office/accessibility">
                  ADA/Title VI Notices
                </a>{" "}
                | <a href="https://bellevuewa.gov/terms-of-use">Terms of Use</a>{" "}
                |{" "}
                <a href="https://bellevuewa.gov/privacy-security">
                  Privacy Policy
                </a>{" "}
                |{" "}
                <Link
                  to="/SiteMap"
                  onClick={() => {
                    window.scrollTo(0, 0); //scroll to the top of the page
                  }}
                >
                  Site Map
                </Link>
                &nbsp;
              </p>
            </div>
          </aside>
        </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
